import React from 'react';
import '../home/Home.css';

export default function OutOfMoney({ setStage, leaderboard, setMoney }) {
  return (
    <div className='home-container'>
      <div className='home-center'>
        <div className='gameover-content'>
          <h1>
            Thank you for playing <span className='black'>493</span>
            <span className='red'>jack</span>
          </h1>
          <h2>
            You lost all of your money!
          </h2>

          <div className='rules-scroll-sm'>
            <ol>
              {leaderboard.map(leader =>
                <li>
                  {leader.name}<span className='align-right'>${leader.money}</span>
                </li>
              )}
            </ol>
          </div>

          <button className='home-rules' onClick={() => {setStage('game'); setMoney(100);}}>
            <i className='fa fa-undo'></i> Play again
          </button>
          <button className='home-board' onClick={() => {setStage('home'); setMoney(100);}}>
            <i className='fa fa-home'></i> Return to home
          </button>
        </div>
      </div>
    </div>
  );
}
